import { DashboardReport, DealMetric, mountReportTotalSingleQuery } from "models/dashboards"

export const mountReportTotalConversionQuery = (props: { report: Partial<DashboardReport> | undefined }) => {
  return {
    ...mountReportTotalSingleQuery(
      props.report as DashboardReport,
      { metric: DealMetric.COUNT, extraParams: { ...props.report?.extraParams, hasDeal: true } },
      "conversion_deals",
    ),
    ...mountReportTotalSingleQuery(
      props.report as DashboardReport,
      { metric: DealMetric.COUNT, extraParams: { ...props.report?.extraParams, hasWonDeal: true } },
      "conversion_deals_won",
    ),
    ...mountReportTotalSingleQuery(
      props.report as DashboardReport,
      { metric: DealMetric.COUNT, extraParams: { ...props.report?.extraParams, hasDeal: false } },
      "conversion_deals_not",
    ),
    // conversion_deals: {
    //   ...props.report,
    //   id: "conversion_deals",
    //   name: "conversion_deals",
    //   extraParams: {
    //     ...props.report?.extraParams,
    //     hasDeal: true,
    //   },
    // },
    // conversion_deals_won: {
    //   ...props.report,
    //   id: "conversion_deals_won",
    //   name: "conversion_deals_won",
    //   extraParams: {
    //     ...props.report?.extraParams,
    //     hasWonDeal: true,
    //   },
    // },
  }
}
